import { useSignal } from "@preact/signals";
import useMessageChannel from "./use-message-channel";
export const EVENT_FILTERS_UPDATED = "Filters.updated";
export default function useOnFiltersReady(callback) {
    const ready = useSignal(false);
    const channel = useMessageChannel();
    const onFiltersReady = () => {
        channel.unsubscribe(EVENT_FILTERS_UPDATED, onFiltersReady);
        ready.value = true;
    };
    channel.subscribe(EVENT_FILTERS_UPDATED, onFiltersReady);
    return (ready.value ? callback() : new Promise(() => { }));
}
